import { isReactNativeWebView } from '../../hybridApp/helpers';

const isHybridApp = isReactNativeWebView();

export const loadingScreenReducer = (state = false, action) => {
    // Skip all loading-screen updates in Hybrid mode
    if (isHybridApp) return false;

    switch (action.type) {
        case "SHOW_LOADING_SCREEN":
            return true;
        case "HIDE_LOADING_SCREEN":
            return false;
        default:
            return state;
    }
};
